"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICONS = void 0;
const chalk_1 = __importDefault(require("chalk"));
exports.ICONS = {
    FAILED: chalk_1.default.bold.red('❌'),
    SUCCESS: chalk_1.default.bold.green('✅'),
    WARNING: chalk_1.default.bold.green('⚠️'),
};
//# sourceMappingURL=formatting.js.map